/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateExhibitorDto } from '../../models/create-exhibitor-dto';
import { ExhibitorDto } from '../../models/exhibitor-dto';

export interface ExhibitorControllerCreateV1$Params {
      body: CreateExhibitorDto
}

export function exhibitorControllerCreateV1(http: HttpClient, rootUrl: string, params: ExhibitorControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitorDto>> {
  const rb = new RequestBuilder(rootUrl, exhibitorControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExhibitorDto>;
    })
  );
}

exhibitorControllerCreateV1.PATH = '/api/v1/exhibitor';
